class ProductCarousel {
    constructor(container) {
        this.container = container;
        this.splideInstance = null;
        this.sectionId = this.container.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');

        this.init();
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.handleSplideSlider();
            });
        } else {
            this.handleSplideSlider();
        }
    }

    handleSplideSlider() {
        if (!this.container) return;

        if (this.splideInstance) {
            this.splideInstance.destroy(true);
            this.splideInstance = null;
        }

        if (typeof Splide === 'undefined') {
            console.error('Splide is not loaded');
            return;
        }

        try {
            this.splideInstance = new Splide(this.container, {
                type: 'slide',
                perPage: 2,
                perMove: 1,
                autoScroll: {
                    speed: 1,
                    rewind: true,
                },
                arrows: false,
                pagination: false,
                gap: '10px',
                drag: true,
                keyboard: true,
                breakpoints: {
                    992: {
                        perPage: 1,
                        gap: '5px',
                    }
                }
            });

            this.splideInstance.mount(window.splide.Extensions);

        } catch (error) {
            console.error('Error initializing Splide:', error);
        }
    }

    destroy() {
        if (this.splideInstance) {
            this.splideInstance.destroy(true);
            this.splideInstance = null;
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const productCarouselSections = document.querySelectorAll('.social-videos-container.splide');
    
    productCarouselSections.forEach(section => {
        new ProductCarousel(section);
    });
});
